import { ref } from 'vue';
import { inovacaoApi } from '@/services/inovacaoApi';

/**
 * Flag "sou avaliador de inovação" (diretor de ≥1 CC no Identidade, ou admin
 * da rota /inovacao). Resolvida uma única vez por sessão via
 * GET /inovacao/sou-avaliador e cacheada em nível de módulo (mesmo padrão do
 * useReembolsoConferenteFlag). `null` = ainda carregando (evita flicker no menu).
 */
const isAvaliador = ref<boolean | null>(null);
let loadPromise: Promise<void> | null = null;

async function load() {
  if (loadPromise) return loadPromise;
  loadPromise = (async () => {
    try {
      const res = await inovacaoApi.souAvaliador();
      isAvaliador.value = Boolean(res.isAvaliador);
    } catch {
      isAvaliador.value = false;
    }
  })();
  return loadPromise;
}

export function useInovacaoAvaliadorFlag() {
  load();
  return { isAvaliador };
}
